import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App"; // Assuming your main component is named App

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
